import { Divider, InputRichText } from '@dixa/lib-shared-habla';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useCopilotTrial } from 'utils/useCopilotTrial';
import { useEditorContext } from 'utils/useEditorContext';

export const Undo = (): JSX.Element | null => {
  const { undo, canUndo } = useEditorContext();
  const { hasCopilot } = useCopilotTrial();
  const flags = useFeatureFlag(['agent-copilot-pin-actions']);

  if (!hasCopilot || !flags.agentCopilotPinActions || !canUndo()) {
    return null;
  }

  return (
    <>
      <Divider orientation="vertical" />
      <InputRichText.ToolbarButton icon="undo" text="Undo" onClick={undo} />
    </>
  );
};
